import { Layout, Space } from "antd";
import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import {
  InstagramFilled,
  FacebookFilled,
  LinkedinFilled,
  XOutlined
} from '@ant-design/icons';
import { Image } from "antd";
const { Header, Footer, Content } = Layout;

export default function PersistentDrawerLeft() {
  let navigate = useNavigate();

  const headerStyle = {
    display: 'flex',
    height: 95,
    backgroundColor: '#ECECEC',
    padding: 10,
    justifyContent: 'center',
    alignItems: 'center',
  };
  const contentStyle = {
    textAlign: 'center',
    backgroundColor: 'white',
  };

  const layoutStyle = {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    borderRadius: 8,
    overflow: 'hidden',
    width: '100%',
    maxWidth: '100%',
  };

  return (
    <Layout style={layoutStyle}>
      <Header style={headerStyle}>
        <Image
          width={130}
          preview={false}
          src={require("../../assets/img/sutas-logo.png")}
          onClick={() => navigate("/Home")}
          style={{ cursor: "pointer" }}
        />

      </Header>
      <Content style={contentStyle}>
        <Outlet />

      </Content>
      <Footer style={contentStyle}>
        <p style={{ fontSize: 16, color: '#616161', fontWeight: 'bold', fontFamily: 'Roboto' }}>İletişim</p>
        <p style={{ fontSize: 16, fontFamily: 'Roboto' }}>Soru, görüş ve önerilerinizi </p>
        <p style={{ fontSize: 16, fontFamily: 'Roboto' }}><span onClick={() => window.open("mailto:kurumsaliletisim@sutas.com.tr")} style={{ fontSize: 16, color: '#109047', fontWeight: 'bold' }}>kurumsaliletisim@sutas.com.tr</span> e-mail adresine iletebilirsiniz.</p>

        <Space>
          <InstagramFilled onClick={() => window.open("https://www.instagram.com/sutastr", "_blank")} style={{ fontSize: 30 }} />
          <FacebookFilled onClick={() => window.open("https://www.facebook.com/TurkiyeninSutcusu", "_blank")} style={{ fontSize: 30 }} />
          <XOutlined onClick={() => window.open("https://x.com/SutasCiftligi", "_blank")} style={{ fontSize: 30 }} />
          <LinkedinFilled onClick={() => window.open("https://www.linkedin.com/company/sutas", "_blank")} style={{ fontSize: 30 }} />
        </Space>
      </Footer>
    </Layout>
  );
}
